<template>
  <div class="main container">
    <div>
      <h1 v-if="!isEdit">Add new agreement</h1>
      <h1 v-else>Edit agreement</h1>

      <!-- Type of Pass -->
      <section id="section-type">
        <div class="form-group">
          <label>Choose type</label>
          <div class="type-pass-content">

            <div class="form-check">
              <input
                v-model="form.agreement_name"
                class="form-check-input form-check-container"
                type="radio"
                name="agreement-type"
                value="Terms and Instructions">
              <label class="form-check-label" for="terms-and-instruction">
                Terms and Instructions
              </label>
            </div>

            <div class="form-check">
              <input
                v-model="form.agreement_name"
                class="form-check-input"
                type="radio"
                name="agreement-type"
                value="Code of Conduct">
              <label class="form-check-label" for="code-of-conduct">
                Code of Conduct
              </label>
            </div>

            <div class="form-check">
              <input
                v-model="form.agreement_name"
                class="form-check-input"
                type="radio"
                name="agreement-type"
                value="Non-disclosure Agreement">
              <label class="form-check-label" for="non-disclosure">
                Non-disclosure Agreement
              </label>
            </div>

            <div class="form-check">
              <input
                v-model="form.agreement_name"
                class="form-check-input"
                type="radio"
                name="agreement-type"
                value="Privacy Policy">
              <label class="form-check-label" for="privacy-policy">
                Privacy Policy
              </label>
            </div>

            <div class="form-check">
              <input
                v-model="form.agreement_name"
                class="form-check-input"
                type="radio"
                name="agreement-type"
                value="Car Parking Rules and Instructions">
              <label class="form-check-label" for="car-parking">
                Car Parking Rules and Instructions
              </label>
            </div>

            <div class="form-check">
              <input
                v-model="form.agreement_name"
                class="form-check-input"
                type="radio"
                name="agreement-type"
                value="Others">
              <label class="form-check-label" for="others">
                Others
              </label>
            </div>

            <div id="section-name" v-if="form.agreement_name === 'Others'">
              
              <form-group v-if="form.other_agreement_name === 'Data Privacy Agreement'">
                <label>Agreement's Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.other_agreement_name"
                  :disabled="form.other_agreement_name === 'Data Privacy Agreement'" />
              </form-group>

              <InputComponent v-else
                class="input-name"
                type="text"
                for="input-agreement-name"
                label_text="Agreement's Name"
                attribute="Agreement Name"
                placeholder="Agreement Name"
                v-model="form.other_agreement_name"
                :v="$v.form.other_agreement_name" />
            </div>

            <small
              v-if="error.agreement_name"
              class="form-text text-muted error-message">
              {{ error.agreement_name }}
            </small>
            <small v-if="errAgreementName" class="form-text text-muted error-message">
              {{ errAgreementName }}
            </small>
          </div>
        </div>
      </section>

      <section id="agreement-url-link">
        <InputComponent
          class="input-name"
          type="text"
          for="input-agreement-link"
          label_text="Link"
          attribute="Link"
          placeholder="Link"
          v-model="form.link"
          :v="$v.form.link" />

          <small v-if="errLink" class="form-text text-muted error-message">
            {{ errLink }}
          </small>
      </section>
      <small v-if="errMessage" class="form-text text-muted error-message">
        {{ errMessage }}
      </small>
      <p class="wysiwyg-intro">Or add your agreement details by typing it below:</p>
      <section>
        <vue-editor
          v-model="form.content"
          :editorToolbar="customToolbar"
          :editorOptions="optionsEditor"
        >
        </vue-editor>
      </section>
    </div>

    <br/>
    <section>
      <small v-if="errorMessage" class="form-text text-muted error-message">
        {{ errorMessage }}
      </small>
      <small v-if="mainErrMessage" class="form-text text-muted error-message">
        {{ mainErrMessage }}
      </small>

      <button @click="validateForm()" type="submit" class="btn btn-primary">
        {{ submitButtonName }}
      </button>
      <button @click="cancelEdit()" type="submit" class="btn btn-primary">
        Cancel
      </button>
    </section>
    <br/><br/>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

import { CommonHelper } from '@/api/helper/CommonHelper'

import InputComponent from '@/components/form/InputComponent'

const commonHelper = new CommonHelper

export default {
  components: {
    InputComponent,
    VueEditor
  },
  data() {
    return {
      customToolbar: [
        [{'header': '2'}], ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, { 'list': 'bullet' }, 'link'],
      ],
      optionsEditor: {
        formats: ['bold','underline','italic','link','list','header'],
      },
      errAgreementName: '',
      errLink: '',
      errMessage: '',
      mainErrMessage: '',
      hasErrors: ''
    }
  },
  props: {
    errorMessage: String,
    submitButtonName: String,
    form: Object,
    error: Object,
    submitForm: Function,
    cancelEdit: Function,
    clearMessage: Function,
    isEdit: Boolean,
  },
  validations: {
    form: {
      other_agreement_name: { minLength: 4 },
      link: { minLength: 10 }
    }
  },
  methods: {
    validateForm() {
      this.clearMessage()
      this.errAgreementName = ''
      this.errMessage = ''
      this.mainErrMessage = ''
      this.hasErrors = false

      this.form.type = this.form.link === '' ? 'wysiwyg' : 'link'

      if(this.form.agreement_name === '' ||
        (this.form.agreement_name === 'Others' && this.form.other_agreement_name === '')) {
        this.errAgreementName = 'Type of agreement is required.'
        this.hasErrors = true
      }

      if(this.form.type === 'link' && this.form.link === '' ||
        this.form.type === 'wysiwyg' && this.form.content === '') {
        this.errMessage = 'Please include a link of your agreement or fill-in the details of your agreement in the editor.'
        this.hasErrors = true
      }

      if(this.form.type === 'link') {
        if(!commonHelper.isValidURL(this.form.link)) {
          this.errMessage = 'Please enter a valid URL.'
          this.hasErrors = true
        }
      }

      if(!this.hasErrors) {
        if(this.form.link !== '' && this.form.content !== '') {
          this.mainErrMessage = 'Please fill-in just 1 field (link field or WYSIWYG field).'
          this.hasErrors = true
        } else {
          this.submitForm()
        }
      } else {
        this.mainErrMessage = 'You might have missed a field. Please check and complete the form. Thank you!'
      }
    }
  }
}

</script>

<style type="text/css" scoped>

.wysiwyg-intro {
  margin-top: 20px;
}

@media (max-width: 568px){
  /deep/.form-group {
    padding-left: 0px;
    padding-right: 0px;
  }

  /deep/.btn-primary {
    margin-top: 15px;
    min-width: 125px;

  }

}
</style>



// WEBPACK FOOTER //
// src/components/agreements/AgreementForm.vue